<template>
  <div v-if="hasMedia" class="product-media-gallery">
    <MediaGallery
      :media="media"
      :useBackgroundImages="true"
      :showCarouselPagination="showCarouselPagination"
      :showLightboxNavigationButtons="false"
      :captionVariant="CAPTION_VARIANTS.centered"
      :carouselSlidePaddingRightMobile="0"
      :carouselSlidePaddingRightDesktop="0"
      :carouselSpaceRightDesktop="0"
      :carouselSpaceRightMobile="0"
    ></MediaGallery>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MediaGallery, { CAPTION_VARIANTS } from '@/components/_shared/MediaGallery/MediaGallery.vue'

export default {
  name: 'ProductMediaGallery',
  components: {
    MediaGallery,
  },

  props: {
    media: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      CAPTION_VARIANTS,
    }
  },

  computed: {
    ...mapGetters({
      isMqLarge: 'viewport/isMqLarge',
    }),
    showCarouselPagination() {
      return !this.isMqLarge
    },
    hasMedia() {
      return this.media.length > 0
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../pdp-settings';

.product-media-gallery {
  @extend %u-pdp-section-height;

  /deep/ .media-gallery {
    &__carousel-image {
      @extend %u-pdp-section-height;
    }
  }
}
</style>
